export default __webpack_public_path__ + "static/881-13b290c0907993e4b674bfebdd9b5dd5.gif";